import React from "react";
import { Button, type ButtonProps } from "@mui/material";

import { useAuthentication } from "../../hooks";
import type { ApplicationName } from "../../types";

type ApplicationButtonColor = "lime" | "coral" | "skyBlue" | "info";

const getButtonColor = (applicationName: ApplicationName, applicationEnvironment?: string): ApplicationButtonColor => {
	if (applicationEnvironment === "preprod") {
		return "info";
	}

	if (applicationName === "TenantManagement" || applicationName === "Company") {
		return "coral";
	}

	if (applicationName === "Support") {
		return "skyBlue";
	}

	return "lime";
};

type AuthenticationButtonProps = Omit<ButtonProps, "color">;

export const AuthenticationButton: React.FC<AuthenticationButtonProps> = (props) => {
	const { applicationName, applicationEnvironment } = useAuthentication();

	return <Button color={getButtonColor(applicationName, applicationEnvironment)} {...props} />;
};
